import constructionNoExperience from "./construction-no-experience";
import fifoNoExperience from "./fifo-no-experience";
import constructionResume from "./construction-resume";
import ticketsLicences from "./tickets-licences";
import fifoInterview from "./fifo-interview";

export const GUIDES = [
  constructionNoExperience,
  fifoNoExperience,
  constructionResume,
  ticketsLicences,
  fifoInterview,
];

export const getGuide = (slug) => GUIDES.find((g) => g.slug === slug);
